import Vue from 'vue'
import VueRouter from 'vue-router'
import { getStore } from '@/util/store'
import { Message } from 'element-ui'

// 解决路由重复跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/Login.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/managerHome.vue'),
  },
  {
    path: '/selectgroup',
    name: 'selectgroup',
    component: () => import('../views/group/selectgroup.vue'),
  },
  {
    path: '/projectLayout',
    name: 'projectLayout',
    component: () => import('../views/project/layout.vue'),
    children: [
      {
        path: '/projectmanager',
        name: 'projectmanager',
        component: () => import('../views/project/ProjectManager.vue')
      },
      {
        path: '/projectinfo',
        name: 'projectinfo',
        component: () => import('../views/project/info.vue')
      },
      {
        path: '/projectdepart',
        name: 'projectdepart',
        component: () => import('../views/project/depart.vue')
      },
      {
        path: '/projectrole',
        name: 'projectrole',
        component: () => import('../views/project/role.vue')
      },
      {
        path: '/projectpreson',
        name: 'projectpreson',
        component: () => import('../views/project/preson.vue')
      },
      {
        path: '/projectsetting',
        name: 'projectsetting',
        component: () => import('../views/project/setting/index.vue')
      },
    ]
  },
  {
    path: '/unitLayout',
    name: 'unitLayout',
    component: () => import('../views/unit/layout.vue'),
    children: [
      //   {
      //   path: '/unitinfo',
      //   name: 'unitinfo',
      //   component: () => import('../views/unit/info.vue')
      // },
      {
        path: '/unitdepart',
        name: 'unitdepart',
        component: () => import('../views/unit/depart.vue')
      },
      {
        path: '/unitrole',
        name: 'unitrole',
        component: () => import('../views/unit/role.vue')
      },
      {
        path: '/unitpreson',
        name: 'unitpreson',
        component: () => import('../views/unit/preson.vue')
      }
    ]
  },
  {
    path: '/groupLayout',
    name: 'groupLayout',
    component: () => import('../views/group/layout.vue'),
    children: [{
      path: '/groupinfo',
      name: 'groupinfo',
      component: () => import('../views/group/info.vue')
    },
    {
      path: '/groupbranchcompany',
      name: 'groupbranchcompany',
      component: () => import('../views/group/branchcompany.vue')
    },
    {
      path: '/groupdepart',
      name: 'groupdepart',
      component: () => import('../views/group/depart.vue')
    },
    {
      path: '/groupproject',
      name: 'groupproject',
      component: () => import('../views/group/project.vue')
    },
    {
      path: '/grouprole',
      name: 'grouprole',
      component: () => import('../views/group/role.vue')
    },
    {
      path: '/grouppreson',
      name: 'grouppreson',
      component: () => import('../views/group/preson.vue')
    },
    {
      path: '/groupsetting',
      name: 'groupsetting',
      component: () => import('../views/group/setting/index.vue')
    },
    {
      path: '/projectprovince',
      name: 'projectprovince',
      component: () => import('../views/project/province.vue')
    }
    ]
  },
  {
    path: '/superadmin',
    name: 'superadmin',
    component: () => import('../views/superadmin/layout.vue'),
    children: [{
      path: '/superadminproject',
      name: 'superadminproject',
      component: () => import('../views/superadmin/project.vue')

    },
    {
      path: '/superadmincompany',
      name: 'superadmincompany',
      component: () => import('../views/superadmin/company.vue')

    },
    {
      path: '/superadminmenu',
      name: 'superadminmenu',
      component: () => import('../views/superadmin/menu.vue')
    },
    {
      path: '/superadminhome',
      name: 'superadminhome',
      component: () => import('../views/superadmin/home.vue')
    },
    {
      path: '/companyMenu',
      name: 'companyMenu',
      component: () => import('../views/superadmin/companyMenu.vue')
    },
    {
      path: '/superadminprovince',
      name: 'superadminprovince',
      component: () => import('../views/superadmin/province.vue')
    },
    //超管账号权限: 动火配电箱管理
    {
      path: '/distributionBoxManagement',
      name: 'distributionBoxManagement',
      component: () => import('../views/superadmin/distributionBox.vue')
    },
    //超管账号权限: 定制化配置
    {
      path: '/customizedManagement',
      name: 'customizedManagement',
      component: () => import('../views/superadmin/customizedManagement.vue')
    },
    //超管  整合用户管理
    {
      path: '/userManagement',
      name: 'userManagement',
      component: () => import('../views/superadmin/userManagement.vue')
    },
    //实施管理
    {
      path: '/implementManagement',
      name: 'implementManagement',
      component: () => import('../views/superadmin/implementManage/index.vue')
    },
    //培训管理
    {
      path: '/trainManagement',
      name: 'trainManagement',
      component: () => import('../views/superadmin/trainManage/index.vue')
    },
	// hardwareStatistic
	{
		path: '/hardwareStatistic',
		name: 'hardwareStatistic',
		component: () => import('../views/superadmin/hardwareStatistic/index.vue')
	}
    ]
  },
]
const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   const token = getStore({ name: 'accessToken' })
//   if (to.name != 'login' && !token) {
//     // 没去登录页，还没token,跳转去登录页面
//     next({
//       name: 'login'
//     })
//     // Message({
//     //   message: '当前操作没有权限，请重新登录',
//     //   type: 'error'
//     // })
//   } else {
//     // 正常跳转
//     next()
//   }
// })

export default router